import React from 'react';
import styled from 'styled-components';
import { Bio } from '../../data/Constants';
import Typewriter from 'typewriter-effect';
import HeroImg from '../../images/HeroImg.jpeg';
import HeroBgAnimation from "../HeroBgAnimation";


const HeroContainer = styled.div`
  background-color: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px;

  @media screen and (max-width: 768px){
    padding: 66px 16px; 
  }

  @media screen and (max-width: 480px){
    padding: 32px 16px;
  }

  @media screen and (min-width:768px){
    clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
  }
  z-index: 1;

`;

const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 50%;
  right: 0;
  bottom: 0;
  left: 50%;
  overflow: hidden;
  width: 80%;
  height: 100%;
  padding: 0 30px;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);


  @media screen and (max-width: 960px){
    padding: 0 0px;
    justify-content: center;
  }
`

const HeroInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media screen and (max-width: 960px){
    flex-direction: column;
  }
`;

const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;

  @media screen and (max-width: 960px){
    order: 2;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  @media screen and (max-width: 640px){
    order: 2;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const HeroRightContainer = styled.div`
  width: 100%;
  order: 2;
  display: flex;
  justify-content: end;
  gap: 12px;
  
  @media screen and (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }
  @media screen and (max-width: 640px) {
    order: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 50px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  
  @media screen and (max-width: 960px) {
    text-align: center;
  }
  @media screen and (max-width: 640px) {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 8px;
  }
`;

const TextLoop = styled.div`
  font-sie: 40px;
  font-weight: 600px;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 68px;
  gap: 12px;
  display: flex;

  @media screen and (max-width: 960px) {
    text-align: center;
  }
  @mmedia screen and (max-width: 640px) {
    font-size: 22px;
    line-height: 48px;
    margin-bottom: 16px;

  }
`;

const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`

const SubTitle = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.text_primary+95};
  line-height: 32px;
  margin-bottom: 42px;

  @media screen and (max-width: 960px){
    text-align: center:
  }
  @media screen and (max-width: 640px){
    font-size: 16px;
    lien-height: 32px;

  }
`


const Image = styled.img`
width: 60%;
height: 80%;;
position: relative;
border-radius: 50%;
max-width: 400px
max-height: 400px;
object-fit: cover;
object-position: center;
border: 2px solid ${({ theme }) => theme.primary}

@media screen and (max-width: 960px){
  max-width:400px;
  max-height: 400px;
}

@media screen and (max-width: 640px){
  max-width: 280px;
  max-height: 280px; 
}
`

// const Image = styled.img`
//   width: 50%; /* Reduced width from 60% */
//   height: 70%; /* Reduced height from 80% */
//   position: relative;
//   border-radius: 50%;
//   max-width: 300px; /* Reduced max-width from 400px */
//   max-height: 450px; /* Reduced max-height from 400px */
//   object-fit: cover;
//   object-position: center;
//   border: 2px solid ${({ theme }) => theme.primary};

//   @media screen and (max-width: 960px) {
//     max-width: 300px; /* Adjusted max-width for responsive design */
//     max-height: 300px; /* Adjusted max-height for responsive design */
//   }

//   @media screen and (max-width: 640px) {
//     max-width: 200px; /* Adjusted max-width for smaller screens */
//     max-height: 200px; /* Adjusted max-height for smaller screens */
//   }
// `;

const Hero = () => {
  return (
    <div id='about'> 
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer>
            <Title>
              Hi, I am <br/>
              {Bio.name}
            </Title>
            <TextLoop>
              I am a
              <Span>
                <Typewriter 
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true
                  }}
                /> 
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            {/* <ResumeButton href={Bio.resume} target="_blank">Check Resume</ResumeButton> */}
          </HeroLeftContainer>
          <HeroRightContainer>
            <Image src={HeroImg} alt="hero"/>
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>

    </div>
  )
}

export default Hero